import { CaseStatus } from '@/@types/generated'

export const OpenCaseStatuses = [
  CaseStatus.NEW,
  CaseStatus.INV_ASSIGNED,
  CaseStatus.INV_IN_REVIEW,
  CaseStatus.ENF_ATTORNEY_REVIEW,
  CaseStatus.ENF_AFO_LTR_MAILED,
  CaseStatus.ENF_HEARING,
  CaseStatus.ENF_FO_LTR_MAILED,
  CaseStatus.ENF_NODD_LTR_MAILED,
  CaseStatus.ENF_MOTION_FOR_REHEARING,
  CaseStatus.ENF_COLLECTIONS,
  CaseStatus.ENF_FIRST_DEMAND_LTR_MAILED,
  CaseStatus.ENF_FINAL_DEMAND_LTR_MAILED,
  CaseStatus.ENF_RESPONSE_RECEIVED,
  CaseStatus.CCMPT_COMPTROLLER_REFERRAL,
  CaseStatus.CCMPTAG_COMPTROLLER_AG_REFERRAL,
  CaseStatus.AV_NOI_NOTICE_OF_INTENT_MAILED,
  CaseStatus.AV_FD_FINAL_DETERMINATION_LTR_MAILED,
] as const satisfies CaseStatus[]

export const ClosedCaseStatuses = [
  CaseStatus.CLOSED_AFTER_FINAL_ORDER,
  CaseStatus.CLOSED_AFTER_HEARING_AND_FINAL_ORDER,
  CaseStatus.CLOSED_AGREED_ORDER,
  CaseStatus.CLOSED_CURED,
  CaseStatus.CCMPT_COMPTROLLER_REFERRAL,
  CaseStatus.CCMPTAG_COMPTROLLER_AG_REFERRAL,
  CaseStatus.CLOSED_DISMISSED,
  CaseStatus.CLOSED_DUPLICATE_COMPLAINT,
  CaseStatus.CLOSED_INSUFFICIENT_EVIDENCE,
  CaseStatus.CLOSED_MEDIATED,
  CaseStatus.CLOSED_NO_VIOLATION,
  CaseStatus.CLOSED_NO_JURISDICTION,
  CaseStatus.CLOSED_OUT_OF_BUSINESS,
  CaseStatus.CLOSED_PAID_AFTER_NODD,
  CaseStatus.CLOSED_REFERRAL_SENT,
  CaseStatus.CLOSED_UNCOLLECTABLE,
  CaseStatus.CLOSED_VOLUNTARY_SURRENDERED,
  CaseStatus.CLOSED_WARNING,
] as const satisfies CaseStatus[]

// Compile-time exhaustiveness check
const AllCaseStatuses = [...OpenCaseStatuses, ...ClosedCaseStatuses] as const
type MissingCaseStatuses = Exclude<CaseStatus, (typeof AllCaseStatuses)[number]>
// If this line causes a TypeScript error, it means that not all CaseStatus values are included
// in either OpenCaseStatuses or ClosedCaseStatuses. Please update the arrays accordingly.
const _allCaseStatusesIncluded: MissingCaseStatuses extends never
  ? true
  : never = true
void _allCaseStatusesIncluded
// End compile-time exhaustiveness check
